module.exports = __webpack_public_path__ + "img/commentTask_example2.4de5e6b8.png";